export class AuthResponse {
  static EXPIRE_THRESHOLD_SECONDS = 86400; // a day before token expire, it is eligable for refresh

  jwt!: string;
  tokenType!: string;
  expiresIn!: number;
  timestamp!: number;

  constructor(data?: Partial<AuthResponse>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  isExpired(): boolean {

    const tokenAge = (Date.now() - this.timestamp) / 1000;
    const remaining = (this.expiresIn * 60) - tokenAge;

    return remaining <= 0;
  }

  isExpireSoon(): boolean {

    const tokenAge = (Date.now() - this.timestamp) / 1000;
    const remaining = (this.expiresIn * 60) - tokenAge;

    return remaining > 0 && remaining <= AuthResponse.EXPIRE_THRESHOLD_SECONDS;
  }

}